<template>
    <div class="pagination_component" v-if="totalNum">
        <span
                class="page_first_last"
                :class="{disable: pageNo === maxPage}"
                @click="toPage(false)"
        >
            末页
        </span>
        <a-pagination
                :current="pageNo"
                :total="totalNum"
                :defaultPageSize="pageSize"
                :itemRender="itemRender"
                @change="changePage"
        />
        <span
                class="page_first_last"
                :class="{disable: pageNo === 1}"
                @click="toPage(1)"
        >
            首页
        </span>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props: {
            pageNo: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 20
            },
            totalNum: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                maxPage: 1
            }
        },
        created() {
            this.maxPage = Math.ceil(this.totalNum / this.pageSize)
        },
        methods: {
            toPage(number) {
                if (!number && this.pageNo === this.maxPage) {
                    return false
                }
                if (number && this.pageNo === 1) {
                    return false
                }
                const page = number || this.maxPage
                this.$emit('change', page)
            },
            changePage(page) {
                this.$emit('change', page)
            },
            itemRender(current, type, originalElement) {
                if (type === 'prev') {
                    return <a>上一页</a>;
                } else if (type === 'next') {
                    return <a>下一页</a>;
                }
                return originalElement;
            }
        },
        watch: {
            totalNum() {
                this.maxPage = Math.ceil(this.totalNum / this.pageSize)
            }
        }
    }
</script>

<style lang="less">
    .pagination_component {
        overflow: hidden;

        .page_first_last {
            float: right;
            height: 32px;
            border: 1px solid #dddddd;
            line-height: 30px;
            box-sizing: border-box;
            border-radius: 5px;
            background: #ffffff;
            padding: 0 10px;
            cursor: pointer;

            &.disable {
                color: #999999;
                cursor: no-drop;
            }
        }

        .ant-pagination {
            float: right;
            margin: 0 8px;

            .ant-pagination-prev, .ant-pagination-next {
                border: 1px solid #dddddd;
                background: #ffffff;

                a {
                    padding: 0 10px;
                }

                &.ant-pagination-disabled {
                    > a {
                        color: #999999;
                    }
                }
            }
        }
    }
</style>